import { motion } from "framer-motion";
import { ShieldCheck, MessagesSquare, Flag, Palette, HeartHandshake, Megaphone, Brain, Users, Lightbulb, Globe2, Puzzle, Star, Handshake, MicVocal, Sparkles } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { fadeUp, stagger, viewportOnce } from "../../lib/motion";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = [ShieldCheck, MessagesSquare, Flag, Palette, HeartHandshake, Megaphone, Brain, Users, Lightbulb, Globe2, Puzzle, Star, Handshake, MicVocal];

export const Benefits = () => {
  const { t } = useLang();
  const s = t.benefits;
  return (
    <section id="benefits" data-testid="benefits-section" className="relative overflow-hidden bg-ink-900 py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/4 h-[360px] w-[360px] rounded-full bg-gold-primary/10 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-8">
        <SectionHeading eyebrow={s.eyebrow} title={s.title} accent={s.accent} subtitle={s.subtitle} testid="benefits-heading" />
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewportOnce} className="mt-16 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4">
          {s.labels.map((label, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <motion.div
                key={label}
                variants={fadeUp}
                data-testid={`benefit-${i}`}
                className="group flex flex-col items-start gap-4 rounded-xl border border-white/10 bg-ink-700/50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-gold-light/40 hover:bg-ink-700"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-gradient-to-br from-gold-light/20 to-gold-primary/10 text-gold-light transition-colors group-hover:from-gold-light group-hover:to-gold-primary group-hover:text-ink-900">
                  <Icon className="h-5 w-5" />
                </span>
                <span className="font-body text-sm font-medium leading-tight text-white/90 md:text-base">{label}</span>
              </motion.div>
            );
          })}
        </motion.div>
        <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewportOnce} className="mt-10 text-center text-xs text-white/40">
          {s.footnote}
        </motion.p>
      </div>
    </section>
  );
};
